/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { modalShellShared } from './modalShellShared.styles';

type Props = {
  onClose: () => void;
  title: string;
  /** Kicker uppercase ink3 (estilo Square module header). */
  kicker?: string;
  subtitle?: string | null;
  /** Slot a la derecha antes de la X (ej. StatusPill del estado — proto gastos). */
  trailing?: React.ReactNode;
  closeAccessibilityLabel?: string;
};

/** Cabecera estándar de modales operativos: kicker + título + X de cierre (Square shell). */
export function ModalScreenHeader({
  onClose,
  title,
  kicker,
  subtitle,
  trailing,
  closeAccessibilityLabel = 'Cerrar',
}: Props) {
  return (
    <View style={modalShellShared.modalHeaderRow}>
      <View style={modalShellShared.modalHeaderTitleBlock}>
        {kicker ? <Text style={modalShellShared.modalHeaderKicker}>{kicker}</Text> : null}
        <Text style={modalShellShared.modalHeaderTitle} accessibilityRole="header">
          {title}
        </Text>
        {subtitle ? (
          <Text style={modalShellShared.sheetSubtitle} numberOfLines={3} ellipsizeMode="tail">
            {subtitle}
          </Text>
        ) : null}
      </View>
      {trailing}
      <TouchableOpacity
        onPress={onClose}
        style={modalShellShared.modalCloseButton}
        hitSlop={8}
        accessibilityRole="button"
        accessibilityLabel={closeAccessibilityLabel}
      >
        <Text style={modalShellShared.modalCloseGlyph}>×</Text>
      </TouchableOpacity>
    </View>
  );
}
